var React = require('react');

function Tortilla3Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M98.2,140.4c-23.3,0-42.1-18.8-42.1-42.1c0-15.6-12.8-28.1-28.1-28.1S0,83.1,0,98.4c0,54.2,44,98.5,98.5,98.5\n\tc54.2,0,98.5-44,98.5-98.5S153-0.1,98.5-0.1c-15.6,0-28.1,12.8-28.1,28.1S83.2,56,98.5,56c23.3,0,42.1,18.8,42.1,42.1\n\tC140.3,121.6,121.1,140.4,98.2,140.4z"}));
}

Tortilla3Inline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 197 200.9","style":{"enableBackground":"new 0 0 197 200.9"},"xmlSpace":"preserve"};

module.exports = Tortilla3Inline;

Tortilla3Inline.default = Tortilla3Inline;
